import { render, staticRenderFns } from "./UpgradePlanModal.vue?vue&type=template&id=152f3262&scoped=true"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=js"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlanModal.vue?vue&type=style&index=0&id=152f3262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f3262",
  null
  
)

export default component.exports